import {
  AfterViewInit,
  ChangeDetectorRef,
  Component
} from '@angular/core';

@Component({
  selector: 'bz-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.sass']
})
export class BzSpinnerComponent implements AfterViewInit {
  constructor(
    private readonly cdr: ChangeDetectorRef
  ) { }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

}
